<template>
  <div class="layout-wrapper">
    <sidebar></sidebar>

    <main class="main-content-area">
    </main>
  </div>
</template>

<script setup>
import Sidebar from "@/components/Sidebar.vue";
</script>
